import type { HTMLAttributes, ReactNode } from "react";

// Card — surface card shell: radius-lg, 1px hairline, --surface fill. The
// hand-rolled enclosure used across panels. Padding/hover/etc. ride in via
// className; this only owns the shell.
//   default → --hairline
//   soft    → --hairline-soft (lighter stroke)

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
    tone?: "default" | "soft";
    children?: ReactNode;
}

export function Card({ tone = "default", className = "", children, ...rest }: CardProps) {
    return (
        <div
            className={`rounded-[var(--radius-lg)] border ${tone === "soft" ? "border-border" : "border-border"} bg-surface ${className}`}
            {...rest}
        >
            {children}
        </div>
    );
}
